export const ContentRelevancyType = {
    RELEVANT: "relevant",
    IRRELEVANT: "irrelevant"
}